module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"videoProcessing":"Video is processing","processingTip":"It can take several minutes.","processingTip2":"Please be patient."}}')
  delete Component.options._Ctor
}
